import { useState, useEffect, useMemo, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import { DateTime } from "luxon";
import { Formik } from "formik";
import { t, use } from "i18next";
import * as Yup from "yup";

import {
  faCreditCard,
  faUniversity,
  faHandHoldingUsd,
  faMoneyCheckAlt,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TableListCuotasUser from "@/shared/components/organisms/TableListCuotasUser";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { SelectCountry } from "@/shared/components/organisms/SelectCountry";
import { ListHistorial } from "@/shared/components/organisms/ListHistorial";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { TabsUser } from "@/shared/components/organisms/TabsUser";
import { Select } from "@/shared/components/organisms/Select";
import InputRadio from "@/shared/components/atoms/InputRadio";

import {
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { FormBankPayment } from "@/shared/components/organisms/FormBankPayment";
import { FormCardPayment } from "@/shared/components/organisms/FormCardPayment";

import {
  FeesValidationSchema,
  AssignFeeUserInitialValues,
} from "@/shared/schemas/pays.schema";

// APIS
import {
  useAssignFeeToUserMutation,
} from "@/app/billing/billing.api"
import {
  useFeesMutation,
  usePriceNextMutation,
  useUnsubscribeUserMutation,
  useDeleteFeeToUserMutation,
  usePauseFeeToUserMutation,
  useGetStatusFeeUserDiscountQuery,
} from "@/app/fees/fees.api";
import {
  useGetAllCountriesQuery,
} from "@/app/app.apiCountry";
import {
  useUserQuery,
  useUserGetQuery,
  useGetStatusUserDiscountQuery,
} from "@/app/users/users.api";
import {
  useReasonsQuery,
} from "@/app/reasons/reasons.api";
import {
  useLazyStripeSetupIntentQuery,
} from "@/app/payments/payments.api";
import {
  useRegistrationPaymentsQuery,
} from "@/app/registration-payments/registration-payments.api";

import { usePaymentIntentMutation } from "@/app/payments/payments.api";

// UTILS
import { Fee } from "@/app/fees/fees";
import {
  FIELD_REQUIRED_MESSAGE,
} from "@/shared/utils/validations";
import { formatDateTime } from "@/shared/utils/formatedDate";
import { validarIBAN } from "@/shared/utils/validationUtils";
import { toasts } from "@/shared/utils/toasts";

import {
  useUpdateMutation,
} from "@/app/fees-user/fees-user.api"

type FeesAssignmentProps = {
  openDialog: () => void,
  setTitleDialog: (value: string) => void,
  setTextButtonSubmit: (value: string) => void,
  setFormSelect: (value: number) => void,
};

export const FeesAssignment: React.FC<FeesAssignmentProps> = ({
  openDialog,
  setTitleDialog,
  setTextButtonSubmit,
  setFormSelect,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [currentFee, setCurrentFee] = useState<Fee>();
  const [idBranch, setIdBranch] = useState(0);
  const [activityFees, setActivityFees] = useState([]);
  const [ToggleStatus, setToggleStatus] = useState(true);

  // Payments process
  const [stripeSetupIntent, stripeSetupIntentResult] =
    useLazyStripeSetupIntentQuery();

  const [sepaDebitPayment, sepaDebitPaymentResult] =
    usePaymentIntentMutation();

  const stripe = useStripe();

  const [cardError, setCardError] = useState("");
  useEffect(() => {
    const handlePaymentIntent = async () => {
      if (sepaDebitPaymentResult.isSuccess) {
        try {
          const { client_secret, status } = sepaDebitPaymentResult.data;

          if (status === "requires_action") {
            const confirmResult = await stripe.confirmCardPayment(client_secret);

            if (confirmResult.error) {
              setCardError(confirmResult.error.message || "Autenticación fallida");
            } else if (confirmResult.paymentIntent.status === "succeeded") {
              toasts.success(
                "Exito",
                "✅ Pago completado con 3D Secure"
              );
            }
          } else if (status === "succeeded") {
            alert("✅ Pago exitoso sin 3D Secure");
          }
        } catch (err) {
          console.error(err);
          toasts.danger(
            "Error",
            "❌ Error procesando el pago"
          );
        }
      }

      if (sepaDebitPaymentResult.isError) {
        toasts.danger(
          "Error",
          sepaDebitPaymentResult.error.data.details
        );
      }
    };
  
    handlePaymentIntent();
  }, [sepaDebitPaymentResult]);


  const getDifferenceInDays = (startDate: string, endDate: string): number => {
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const differenceInTime = end - start;
  
    // Convertir la diferencia de milisegundos a días
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  
    return Math.ceil(differenceInDays); // Redondear hacia arriba si es necesario
  };

  // GENERATE BILL
  const [assignFeeToUser, assignFeeToUserResult] = useAssignFeeToUserMutation();

useEffect(() => {
  const handleAssignFee = async () => {
    if (assignFeeToUserResult.isSuccess) {
      toasts.success(
        "Exto",
        "Cuotas asignada con exito"
      );

      await userQuery.refetch();

      getterFees({
        branchId: idBranch,
      });
      setOpenDialogAsingFee(false);
    }
    if (assignFeeToUserResult.isError) {
      toasts.danger(
        "Error",
        "La cuota no pudo ser asignada"
      );
      setOpenDialogAsingFee(false);
    }
  };

  handleAssignFee();
}, [assignFeeToUserResult]);

  // HANDLE MODAL ASIGN FEES
  const [openDialogAsingFee, setOpenDialogAsingFee] = useState(false);
  const handleOpenDialogAsingFee = (id: number) => {
    setCurrentFee(feesList.find(fee => fee.id === id))
    setOpenDialogAsingFee(!openDialogAsingFee);
  }

  const [feeSelected, setFeeSelected] = useState<Fee>();

  // HANDLE MODAL MODIFY FEES
  const [openDialogModifyFee, setOpenDialogModifyFee] = useState(false);
  const handleOpenDialogModifyFee = (fee: Fee) => {
    setFeeSelected(fee);
    setOpenDialogModifyFee(!openDialogModifyFee);
  };

  // HANDLE MODAL NEXT PAYMENT
  const [openDialogNextPayment, setOpenDialogNextPayment] = useState(false);
  const handleOpenDialogNextPayment = (fee: Fee) => {
    setFeeSelected(fee);
    setOpenDialogNextPayment(!openDialogNextPayment);
  };

  // HANDLE MODAL DISCONTINUE
  const [openDialogDiscontinue, setOpenDialogDiscontinue] = useState(false);
  const handleOpenDialogDiscontinue = (fee: Fee) => {
    setFeeSelected(fee);
    setOpenDialogDiscontinue(!openDialogDiscontinue);
  };

  // HANDLE MODAL CANCEL FEES
  const [openDialogCancelFee, setOpenDialogCancelFee] = useState(false);
  const handleOpenDialogCancelFee = (fee: Fee) => {
    setFeeSelected(fee);
    setOpenDialogCancelFee(!openDialogCancelFee);
  };

  // HADLE MODAL PAUSE FEE
  const [openDialogPauseFee, setOpenDialogPauseFee] = useState(false);
  const handleOpenDialogPauseFee = (fee: Fee) => {
    setFeeSelected(fee);
    setOpenDialogPauseFee(!openDialogPauseFee);
  };

  // TABS COUTAS
  const [selectedTabCuota, setSelectedTabCuota] = useState(1);
  const tabsCuotas = [
    { id: 1, name: t("accounting.views.cuotas") },
    { id: 2, name: t("user.views.history") },
  ];
  const handleTabChangeCuota = (tabId: any) => {
    setSelectedTabCuota(tabId);
  };

  const [selectedOption, setSelectedOption] = useState("payment_cash");
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // OPTIONS BRANDED ACTIVE FEE
  const OptionsBrandedActiveFee = [
    {
      id: 1,
      title: t("share.views.edit"),
      description: "Modificar fecha de renovación",
      function: () => {
        openDialog();
        setTitleDialog(t("user.views.update_feeUser"));
        setTextButtonSubmit(t("general.save"));
        setFormSelect(1);
      },
    },
    {
      id: 2,
      title: t("fees.views.next_pay"),
      description: "Modificar proximo pago",
      function: () => {
        openDialog();
        setTitleDialog(t("fees.views.next_pay"));
        setTextButtonSubmit(t("general.accept"));
        setFormSelect(2);
      },
    },
    {
      id: 3,
      title: t("fees.views.button_pay"),
      description: "Generar Pago",
      function: () => {
        openDialog();
        setTitleDialog(t("fees.views.assign_fee_user"));
        setTextButtonSubmit(t("branch.views.confir"));
        setFormSelect(3);
      },
    },
    {
      id: 4,
      title: t("fees.views.button_low"),
      description: "Dar de baja",
      function: () => {
        openDialog();
        setTitleDialog(t("fees.views.title_modal_confirm_low"));
        setTextButtonSubmit(t("general.accept"));
        setFormSelect(4);
      },
    },
    {
      id: 5,
      title: t("fees.views.cancel"),
      description: "Anular cuota",
      function: () => {
        openDialog();
        setTitleDialog(t("fees.views.cancel_fee"));
        setTextButtonSubmit(t("general.accept"));
        setFormSelect(5);
      },
    },
    {
      id: 6,
      title: t("fees.views.pause"),
      description: "Pausar Couta",
      function: () => {
        openDialog();
        setTitleDialog(t("customer-to-gym-subscription.views.pause"));
        setTextButtonSubmit(t("general.accept"));
        setFormSelect(6);
      },
    },
  ];
  //SELECT TYPE PAYMENT
  const optionsTypePayment = [
    { id: 1, name: t("direct_debit.views.payment_manual_1") },
    { id: 2, name: t("direct_debit.views.payment_manual_2") },
    { id: 3, name: t("direct_debit.views.payment_manual_3") },
    { id: 4, name: t("direct_debit.views.payment_manual_4") },
    { id: 5, name: t("direct_debit.views.payment_manual_5") },
  ];
  //SELECT HACIENDA
  const optionsHacienda = [
    { id: 1, name: t("gti.views.not_generate") },
    { id: 2, name: t("accounting.views.ticket") },
    { id: 3, name: t("gti.views.invoice") },
  ];
  //SELECT TYPE ID
  const optionsTypeId = [
    { id: 1, name: t("store.views.cedula_fisica") },
    { id: 2, name: t("store.views.cedula_juridica") },
    { id: 3, name: t("store.views.dimex") },
    { id: 4, name: t("store.views.nite") },
    { id: 5, name: t("store.views.extranjera") },
  ];

  // INITIAL VALUES FORM NEXT PAY
  const [initialValuesNextPay, setInitialValuesNextPay] = useState({
    price: 0,
    reason_next: "",
  });


  // Querys
  const userShowData = useUserQuery({ id });
  const userQuery = useUserGetQuery({ id });

  const reasonsQuery = useReasonsQuery(
    { branchId: idBranch },
    { skip: idBranch <= 0 }
  );
  const registrationPaymentsQuery = useRegistrationPaymentsQuery(
    { branchId: idBranch },
    { skip: idBranch <= 0 }
  );


  const [userCompleteData, setUserCompleteData] = useState(null);
  useEffect(() => {
    if (userShowData.isSuccess) {
      setUserCompleteData(userShowData.data);
    }
  }, [userShowData]);

  useEffect(() => {
    if (userQuery.data) {
      setToggleStatus(userQuery.data.active);
      setIdBranch(userQuery.data.branch.id);

    setActivityFees(
        [...userQuery.data.feeHistory]
          .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
          .map((fee) => ({
            name: fee.fee.name,
            description: t(fee.description),
            date: formatDateTime(fee.createdAt),
            hour: DateTime.fromISO(fee.createdAt).toFormat("HH:mm"),
          }))
      );
    }
  }, [userQuery]);

  const statusUserDiscountQuery = useGetStatusUserDiscountQuery(
    currentFee ? { branchId: idBranch, feeId: currentFee.id, userId: id } : skipToken
  );

  const [statusUser, setStatusUser] = useState(null);  
  useEffect(() => {
    if (statusUserDiscountQuery.isSuccess) {
      setStatusUser(statusUserDiscountQuery.data.data);
    }
  }, [statusUserDiscountQuery]);

  const [priceInit, setPriceInit] = useState(null);
  const [priceProportional, setPriceProportional] = useState(null);
  const [priceProportionalInit, setPriceProportionalInit] = useState(null);

  useEffect(() => {
    if (currentFee) {
      setPriceInit(statusUser ? currentFee.price - currentFee.price * (statusUser.discount) : currentFee.price);

      // console.log( "Este es el current Fee: ", currentFee )

      // setPriceProportionalInit(statusUser ? currentFee.price_proportional - currentFee.price_proportional * (statusUser.discount  / 100) : currentFee.price_proportional)

      // $price_proportional_init =  $statusUser ? $fee->price_proportional - $fee->price_proportional * ($statusUser->discount  / 100) : $fee->price_proportional;
      // $price_proportional = $status ? $price_proportional_init  - $price_proportional_init * ($fee->discount / 100) : $price_proportional_init;

    }
  }, [statusUser, currentFee]);


  const statusFeeUserDiscountQuery = useGetStatusFeeUserDiscountQuery(
    currentFee ? { branchId: idBranch, feeId: currentFee.id, userId: id } : skipToken
  );
  
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (statusFeeUserDiscountQuery.isSuccess) {
      setStatus(statusFeeUserDiscountQuery.data);
    }
  }, [statusFeeUserDiscountQuery]);

  const [price, setPrice] = useState(null);
  useEffect(() => {
    if (priceInit) {
      setPrice( status ? priceInit - priceInit * (currentFee.discount / 100) : priceInit );
    }
  }, [status, priceInit]);


  const [feesList, setFeesList] = useState([]);

  const [getterFees, getterFeesResult] = useFeesMutation();

  useEffect(() => {
    if (idBranch) {
      getterFees({
        branchId: idBranch,
      });
    }
  }, [idBranch]);

  useEffect(() => {
    if (getterFeesResult.isSuccess) {
      setFeesList(getterFeesResult.data);
    }
  }, [getterFeesResult]);

  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (userQuery.data) {
      setUserInfo(userQuery.data);
    }
  }, [userQuery]);


  const [stateFeeCourse,  setStateFeeCourse] = useState(false);
  const [activeCurrentQuota,  setActiveCurrentQuota] = useState(undefined);
  const [activeCurrentQuotaCourse,  setActiveCurrentQuotaCourse] = useState();
  const [activeCurrentBond,  setActiveCurrentBond] = useState();

  const [activeCurrentSlotBond, setActiveCurrentSlotBond] = useState();
  const [remaining, setRemaining] = useState();
  const [remainingAmount, setRemainingAmount] = useState(0);
  
  useEffect(() => {
    if (userInfo) {
      setStateFeeCourse(false);

      setActiveCurrentQuota(userInfo.stateFee);
      setActiveCurrentQuotaCourse(userInfo.stateFeeFourse);
      setActiveCurrentBond(userInfo.stateBond)
  
      setActiveCurrentSlotBond(userInfo.stateSlotBond)
    }
  }, [userInfo])

  useEffect(() => {
    if (activeCurrentQuota) {
      setRemaining(activeCurrentQuota ? activeCurrentQuota.remaining : false);
      setRemainingAmount(activeCurrentQuota ? activeCurrentQuota.remainingAmount : false);
    }
  }, [activeCurrentQuota]);

  useEffect(() => {
    if (feeSelected) {
      const priceFeeUser = activeCurrentQuota ? (feeSelected.id == activeCurrentQuota.feeId ? (activeCurrentQuota.priceNext !== null ? (activeCurrentQuota.priceNext / 100) : null) : null) : null;
      const priceOrigin = priceFeeUser !== null ? priceFeeUser : feeSelected.price / 100;

      setInitialValuesNextPay({
        ...initialValuesNextPay,
        price: priceOrigin
      });
    }
  }, [feeSelected]);

  useEffect(() => {
    if (remainingAmount && userInfo) {
      setRemainingAmount(!remainingAmount ? (userInfo.fee_next ? userInfo.fee_next.remaining_amount : remainingAmount ) : remainingAmount)
    }
  }, [remainingAmount, userInfo]);

  const [optionsCountryApi, setOptionsCountryApi] = useState([]);

  //TRAER PAISES PARA SELECT COUNTRIES
  const {
    data: countries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useGetAllCountriesQuery({});

  useEffect(() => {
    // Verifica que no esté cargando y que no haya errores
    if (!isLoadingCountries && !isErrorCountries && countries?.length > 0) {
      // Mapea y transforma los datos de los países
      console.debug(countries);
      const arrayCountries = countries.map((country) => ({
        id: country.name.common,
        name: country.name.common,
        code: country.cca2,
      }));

      // Actualiza el estado con los países formateados
      setOptionsCountryApi(arrayCountries);
    }

    // Manejamos los errores
    if (isErrorCountries) {
      console.log("ERROR EN LOS COUNTRIES");
    }
  }, [countries, isLoadingCountries, isErrorCountries]);

  // QUERYS PROCESS FEES
  const [updateFeesUser, updateFeesUserResult] = useUpdateMutation();

  useEffect(() => {
    const handleUpdateFeesUser = async () => {
      if (updateFeesUserResult.isSuccess) {
        toasts.success(
          "Exito",
          "Se ha actualizado la cuota correctamente",
        );

        await userQuery.refetch();

        getterFees({
          branchId: idBranch,
        });

        setOpenDialogModifyFee(false);
      }
      if (updateFeesUserResult.isError) {
        toasts.danger(
          "Error",
          "Fee actualizada exitosamente",
        )
      }
    };

    handleUpdateFeesUser();
  }, [updateFeesUserResult]);

  const [prayNextFee, prayNextFeeResult] = usePriceNextMutation();

  useEffect(() => {

    const handlePrayNextFee = async () => {
      if (prayNextFeeResult.isSuccess) {
        toasts.success(
          "Exito",
          "Se ha registrado el proximo pago correctamente.",
        );

        await userQuery.refetch();

        getterFees({
          branchId: idBranch,
        });

        setOpenDialogNextPayment(false);
      }
      if (prayNextFeeResult.isError) {
        toasts.danger(
          "Error",
          "No se ha podido registrado el proximo pago.",
        );
      }
    };

    handlePrayNextFee();
  }, [prayNextFeeResult]);

  const [unsubscribeUser, unsubscribeUserResult] = useUnsubscribeUserMutation();

  useEffect(() => {

    const handleUnsubscribeUser = async () => {
      if (unsubscribeUserResult.isSuccess) {
        toasts.success(
          "Exito",
          "Se ha actualizado la cuota correctamente",
        );

        await userQuery.refetch();

        getterFees({
          branchId: idBranch,
        });

        setOpenDialogDiscontinue(false);
      }
      if (unsubscribeUserResult.isError) {
        toasts.danger(
          "Error",
          "No es posible darse de baja de esta cuota.",
        );
      }
    };

    handleUnsubscribeUser();
  }, [unsubscribeUserResult]);

  const [deleteFeeToUser, deleteFeeToUserResult] = useDeleteFeeToUserMutation();

  useEffect(() => {
    const handleDeleteFeeUser = async () => {
      if (deleteFeeToUserResult.isSuccess) {
        toasts.success(
          "Exito",
          "Se ha eliminado al usuario de la cuota correctamente",
        );

        await userQuery.refetch();

        getterFees({
          branchId: idBranch,
        });
        setOpenDialogCancelFee(false);
      }

      if (deleteFeeToUserResult.isError) {
        toasts.danger(
          "Error",
          "No es posible darse de baja de esta cuota.",
        );
        setOpenDialogCancelFee(false);
      }
    };

    handleDeleteFeeUser();
  }, [deleteFeeToUserResult]);


  const [pauseFeeToUser, pauseFeeToUserResult] = usePauseFeeToUserMutation();

  useEffect(() => {
    const handleDeleteFeeUser = async () => {
      if (pauseFeeToUserResult.isSuccess) {
        toasts.success(
          "Exito",
          "Cuota pausada exitosamente",
        );
        

        await userQuery.refetch();

        getterFees({
          branchId: idBranch,
        });

        setOpenDialogPauseFee(false);
      }
      if (pauseFeeToUserResult.isError) {
        toasts.danger(
          "Error",
          "No se pudo pausar la cuota",
        )
      }
    }

    handleDeleteFeeUser();
  }, [pauseFeeToUserResult]);

  const stripePromise = useMemo(() => {
    if (userCompleteData?.STRIPEPUBLICKEY) {
      return loadStripe(userCompleteData.STRIPEPUBLICKEY);
    }
    return null;
  }, [userCompleteData]);

  const [priceCurrentFee, setPriceCurrentFee] = useState(0);
  useEffect(() => {
    if (currentFee && !remainingAmount) {
      // Aplica el descuento solo si existe
      const precioBase = currentFee.price / 100; // Si quieres mostrar en euros/dólares
      const descuento = currentFee.discount || 0;
      const precioConDescuento = precioBase - (precioBase * (descuento / 100));
      setPriceCurrentFee(precioConDescuento);
    } else if (currentFee) {
      setPriceCurrentFee(currentFee.price / 100);
    }

    if (remainingAmount) {
      setPriceCurrentFee(remainingAmount);
    }
  }, [currentFee, remainingAmount]);

  return (
    <Fragment>
      <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10  mb-5 md:mb-3">
        {t("accounting.views.cuotas")}
      </h1>

      <TabsUser
        tabs={tabsCuotas}
        selectedTab={selectedTabCuota}
        handleTabChange={handleTabChangeCuota}
        button={
          <ButtonSoft
            text={t("user.views.manage_fees")}
            size="large"
            onClick={() => navigate(`/branchs/${idBranch}/fees`)}
          />
        }
      />
      {selectedTabCuota === 1 ? (
        <>
          {userInfo && userInfo.feePaymentPending && userInfo.feePaymentPending.product === 'fee' && userInfo.feePaymentPending.fee && userInfo.paymenPendingRecurrent ? (
            <div className="col-span-full my-5">
              <p className="text-center text-sm text-orange-400">
                {t('fees.views.card_payment_alert_3')}
                {userInfo.feePaymentPending.fee.name}
                {t('fees.views.card_payment_alert_3_1')}
              </p>
            </div>
          ) : null}

          {userInfo && userInfo.paymenPendingRecurrent && userInfo.paymenPendingRecurrent.product == 'fee' ? (
            <div className="col-span-full my-5">
              <p className="text-center text-sm text-orange-400">
                Estimado usuario, queremos informarte que el pago recurrente se encuentra actualmente en proceso. Nuestro equipo está trabajando para asegurar que el proceso se realice de manera exitosa. ¡Gracias por tu paciencia y confianza en nuestros servicios!
              </p>
            </div>
          ): null}

          <TableListCuotasUser
            user={userQuery.data ?? null}
            coutas={feesList ?? []}
            titleBranded={t("bond.views.assign")}
            titleBrandedActiveFee={t("user.views.actions")}
            OptionsBrandedActiveFee={OptionsBrandedActiveFee}
            activeCurrentQuota={activeCurrentQuota}
            onClickAssingFee={handleOpenDialogAsingFee}
            onClickModifyFee={handleOpenDialogModifyFee}
            onClickNextPayment={handleOpenDialogNextPayment}
            onClickPay={handleOpenDialogAsingFee}
            onClickDiscontinue={handleOpenDialogDiscontinue}
            onClickCancelFee={handleOpenDialogCancelFee}
            onClickPauseFee={handleOpenDialogPauseFee}
          />
        </>
      ) : (
        <>
          {selectedTabCuota === 2 && (
            <ListHistorial history={activityFees} />
          )}
        </>
      )}

      {priceCurrentFee > 0 && (
        <Formik
          enableReinitialize
          initialValues={AssignFeeUserInitialValues}
          validationSchema={FeesValidationSchema({ maxAmount: priceCurrentFee })}
          onSubmit={async (values, formikHelpers) => {
            if ( selectedOption === "payment_direct_debit_manual" ) {
              const isValidIBAN = await validarIBAN(values.iban);
              if (!isValidIBAN) {
                formikHelpers.setErrors({
                  iban: "El IBAN no es válido. Por favor, introduce un IBAN válido.",
                });
                return;
              }
            }


            let method = '';
            switch (selectedOption) {
              case "payment_card":
                  method = "card";
                  await sepaDebitPayment({
                    user_id: id,
                    payment_method: "pm_card_authenticationRequired",
                    payment_method_type: "card",
                    price: values.amount_to_pay,
                    currency: currentFee.currency,
                    type_product: 'fee',
                    product: currentFee.id,
                  })
                break;
              case "payment_cash":
                  method = "cash";
                  await assignFeeToUser({
                    branchId: idBranch,
                    data: {
                      user_id: id,
                      fee_id: currentFee.id,
                      //"generate_in_treasury": generate_in_treasury,
                      generate_in_treasury: 1,
                      parcial: values.payment_parcial,
                      cash_type: values.cash_subscription_type,
                      manual_type: values.typePayment,
                      method: method,
                      identification_type: values.dni,
                      number_id: values.nroDni,
                      // reason_id: values.reasons_payment, // confirmar valor
                      // registration_payment: values.registration_payment,
                      amount_to_pay: values.amount_to_pay,
                      remaining: values.remaining,
                      start_date: values.start_date,
                      manual_comment : values.comment_code,
                    }
                  });
                break;
              case "payment_direct_debit_manual":
                  method = "direct_debit_manual";
                  await assignFeeToUser({
                    branchId: idBranch,
                    data: {
                      user_id: id,
                      fee_id: currentFee.id,
                      amount_to_pay: values.amount_to_pay,
                      method: method,
                    }
                  });
                break;
              case "sepa_debit":
                  method = "sepa_debit";
                  await assignFeeToUser({
                    branchId: idBranch,
                    data: {
                      user_id: id,
                      fee_id: currentFee.id,
                      amount_to_pay: values.amount_to_pay,
                      method: method,
                    }
                  });
                break;

              default:
                  toasts.danger(
                    "Error",
                    "No se ha podido asignar la cuota al usuario"
                  )
                break;
            }
          }}
        >
          {({ values, handleSubmit, handleChange, setFieldValue, errors, touched, isValid }) => {

            useEffect(() => {
              if (currentFee && !remainingAmount) {
                // Aplica el descuento solo si existe
                const precioBase = currentFee.price / 100; // Si quieres mostrar en euros/dólares
                const descuento = currentFee.discount || 0;
                const precioConDescuento = precioBase - (precioBase * (descuento / 100));
                setFieldValue("amount_to_pay", precioConDescuento);
              } else if (currentFee) {
                setFieldValue("amount_to_pay", currentFee.price / 100);
              }

              if (remainingAmount) {
                setFieldValue("remaining", true);
                setFieldValue("amount_to_pay", remainingAmount);
              }
            }, [currentFee, remainingAmount]);

            return (
              <DialogCreate
                open={openDialogAsingFee}
                setOpen={setOpenDialogAsingFee}
                tittle={t("fees.views.assign_fee_user")}
                tittleButtonCreate={t("user.views.confirm")}
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                OnclickCancel={() => setOpenDialogAsingFee(false)}
                isLoading={assignFeeToUserResult.isLoading}
                acceptDisabled={!isValid}
              >
                <div className="mt-6 mx-2">
                  <div className="">
                    
                    {!activeCurrentQuota && reasonsQuery.isSuccess && registrationPaymentsQuery.isSuccess ? (
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200 mt-12">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("user.views.reason_for_discharge")}
                            </h2>
                          </div>
                        </div>

                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <div
                              role="group"
                              aria-labelledby="paymentMethod"
                              className="flex flex-col space-y-2 ml-2 mt-2"
                            >
                              <div className="col-span-full">
                                <Select
                                  name="reasons_payment"
                                  span={t("general.optional")}
                                  selected={(reasonsQuery.data ? reasonsQuery.data.filter(value => value.type == 2).map((reason, index) => ({
                                    id: reason.id,
                                    name: reason.description,
                                  })) : []).find(
                                    (option) => option.id === values.reasons_payment
                                  )}
                                  setSelected={(value) => {
                                    setFieldValue("reasons_payment", value.id);
                                  }}
                                  options={reasonsQuery.data ? reasonsQuery.data.filter(value => value.type == 2).map((reason, index) => ({
                                    id: reason.id,
                                    name: reason.description,
                                  })) : []}
                                  tittle={t(
                                    "user.views.reason_for_discharge"
                                  )}
                                  error={errors.reasons_payment ? true : false}
                                  textError={errors.reasons_payment}
                                />
                              </div>

                              <div className="col-span-full">
                                <Select
                                  name="registration_payment"
                                  span={t("general.optional")}
                                  selected={(registrationPaymentsQuery.data.map((reason, index) => ({
                                    id: reason.id,
                                    name: `${reason.name} - ${reason.price} ${reason.currency}`,
                                  })) ?? []).find(
                                    (option) => option.id === values.registration_payment
                                  )}
                                  setSelected={(value) => {
                                    setFieldValue("registration_payment", value.id);
                                  }}
                                  options={registrationPaymentsQuery.data.map((reason, index) => ({
                                    id: reason.id,
                                    name: `${reason.name} - ${reason.price} ${reason.currency}`,
                                  })) ?? []}
                                  tittle={t(
                                    "customer-to-gym-subscription.views.registration"
                                  )}
                                  error={errors.registration_payment ? true : false}
                                  textError={errors.registration_payment}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200 mt-12">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("fees.views.select_method")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <div
                            role="group"
                            aria-labelledby="paymentMethod"
                            className="flex flex-col space-y-2 ml-2 mt-2"
                          >
                            {userInfo && userInfo.branch ? (
                              <>
                                {userInfo.branch.paymentCardModule &&
                                  userInfo.branch.gateway == 'wompi' &&
                                  userInfo.branch.publicKeyPayment &&
                                  userInfo.branch.privateKeyPayment &&
                                  !remaining ? (
                                    <label
                                      htmlFor="payment_card"
                                      className="flex items-center"
                                    >
                                      <InputRadio
                                        id="payment_card"
                                        key={1}
                                        value="payment_card"
                                        name="payment_card"
                                        checked={selectedOption === "payment_card"}
                                        onChange={handleRadioChange}
                                      />
                                      <FontAwesomeIcon icon={faCreditCard} className="ml-2" />
                                      <span className="ml-2">{t("store.views.card")}</span>
                                    </label>
                                ): null}

                                {userCompleteData && userInfo.branch.paymentCardModule &&
                                  userInfo.branch.gateway == 'stripe' &&
                                  userCompleteData.userWithStripeAccount &&
                                  !remaining ? (
                                  <>
                                    <label
                                      htmlFor="payment_card"
                                      className="flex items-center"
                                    >
                                      <InputRadio
                                        id="payment_card"
                                        key={1}
                                        value="payment_card"
                                        name="payment_card"
                                        checked={selectedOption === "payment_card"}
                                        onChange={handleRadioChange}
                                      />
                                      <FontAwesomeIcon icon={faCreditCard} className="ml-2" />
                                      <span className="ml-2">{t("store.views.card")}</span>
                                    </label>

                                    <label
                                      htmlFor="sepa_debit"
                                      className="flex items-center"
                                      >
                                      <InputRadio
                                        id="sepa_debit"
                                        key={2}
                                        value="sepa_debit"
                                        name="sepa_debit"
                                        checked={selectedOption === "sepa_debit"}
                                        onChange={handleRadioChange}
                                      />
                                      <FontAwesomeIcon icon={faUniversity} className="ml-2" />
                                      <span className="ml-2">{t("store.views.direct_debit")}</span>
                                    </label>
                                  </>
                                ): null}

                                <label
                                  htmlFor="payment_cash"
                                  className="flex items-center"
                                >
                                  <InputRadio
                                    id="payment_cash"
                                    key={3}
                                    name="payment_cash"
                                    value="payment_cash"
                                    checked={selectedOption === "payment_cash"}
                                    onChange={handleRadioChange}
                                  />
                                  <FontAwesomeIcon
                                    icon={faHandHoldingUsd}
                                    className="ml-2"
                                  />
                                  <span className="ml-2">
                                    {t("fees.views.payment_cash")}
                                  </span>
                                </label>

                                {userInfo.branch.directDebitModule &&
                                  userInfo.branch.gateway != 'wompi' &&
                                  !remaining ? (
                                    <label
                                      htmlFor="payment_direct_debit_manual"
                                      className="flex items-center"
                                    >
                                      <InputRadio
                                        id="payment_direct_debit_manual"
                                        key={4}
                                        name="payment_direct_debit_manual"
                                        value="payment_direct_debit_manual"
                                        checked={
                                          selectedOption === "payment_direct_debit_manual"
                                        }
                                        onChange={handleRadioChange}
                                      />
                                      <FontAwesomeIcon
                                        icon={faMoneyCheckAlt}
                                        className="ml-2"
                                      />
                                      <span className="ml-2">
                                        {t("fees.views.payment_direct_debit_manual")}
                                      </span>
                                    </label>
                                  ): null
                                }
                              </>
                            ): null}
                          </div>
                        </div>
                      </div>
                    </div>

                    {(
                      selectedOption === "payment_card" ||
                      selectedOption === "sepa_debit" ||
                      selectedOption === "payment_direct_debit_manual"
                    ) &&  (
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3 mt-12">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("user.views.info_payment_cash")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 md:col-span-2 pb-12">

                          {selectedOption === "payment_card" && (
                            <>
                              {userCompleteData && stripeSetupIntentResult && userInfo && userInfo.branch ? (
                              
                                  <FormCardPayment
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    touched={touched}
                                    values={values}
                                    errors={errors}
                                  />
                              ):null}
                            </>
                          )}
                        
                          {selectedOption === "sepa_debit" && (
                            <>
                              {userCompleteData && stripeSetupIntentResult && userInfo && userInfo.branch && stripePromise ? (
                                  <FormBankPayment
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    values={{
                                      iban: values.iban,
                                      name: values.name,
                                      email: values.email,
                                      address: values.address,
                                      country: values.country,
                                    }}
                                    errors={errors}
                                    touched={touched}
                                  />
                              ):null}
                            </>
                          )}

                          {selectedOption === "payment_direct_debit_manual" && (
                            <>
                              <div className="col-span-full">
                                <p className="text-sm text-gray-600 text-justify font-light">
                                  {t("direct_debit.views.payment_message")}
                                </p>
                              </div>

                              <div className="col-span-full">
                                <span className="text-gray-600 text-sm">
                                  {t("direct_debit.views.text_payment_select_5")}
                                </span>
                              </div>

                              <div className="col-span-full">
                                <div
                                  role="group"
                                  aria-labelledby="acceptPayment"
                                  className="flex flex-col space-y-2"
                                >
                                  <label
                                    htmlFor="payment_complete"
                                    className="flex items-center"
                                  >
                                    <InputRadio
                                      id="payment_complete"
                                      key={2}
                                      value="payment_complete"
                                      name="payment_complete"
                                      //checked={selectedOption === "payment_complete"}
                                      //onChange={handleRadioChange}
                                    />
                                    <span className="ml-2">{t("direct_debit.views.payment_complete")} ({values.amount_to_pay} {currentFee.currency.toLocaleUpperCase()})</span>
                                  </label>
                                </div>
                              </div>

                              {statusUser && (
                                <div className="col-span-full">
                                  <p className="text-center text-sm text-gray-600"> El usuario con etiqueta <span className="discount_name text-cyan-500"> {statusUser.name} </span> tiene un descuento del <span className="discount_rate">{statusUser.discount}</span>%, en esta cuota.</p>
                                </div>
                              )}
                              
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {selectedOption === "payment_cash" && (
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3 border-t border-gray-200 pt-10">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("direct_debit.views.payment")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 sm:grid-cols-6 md:col-span-2 pb-5">

                          <div className="col-span-full">
                            <Select
                              name="typePayment"
                              span={t("general.mandatory")}
                              selected={optionsTypePayment.find(
                                (option) => option.id === values.typePayment
                              )}
                              setSelected={(value) => {
                                setFieldValue("typePayment", value.id);
                              }}
                              options={optionsTypePayment}
                              tittle={t(
                                "direct_debit.views.payment_manual_message"
                              )}
                              error={errors.typePayment ? true : false}
                              textError={errors.typePayment}
                            />
                          </div>


                          {activeCurrentQuota || userInfo.feeNext && (
                            <div className="col-span-full mt-6">
                              <InputWithCornerHint
                                label={t("forms.label.start_date")}
                                span={t("general.mandatory")}
                                name="start_date"
                                type="date"
                                value={values.start_date}
                                onChange={handleChange}
                                error={!!errors.start_date}
                                textError={errors.start_date}
                              />
                            </div>
                          )}


                          {activeCurrentQuota || userInfo.feeNext && (
                            <>
                              <div className="col-span-full mt-6">
                                <span className="text-gray-600 text-sm">
                                  {t("direct_debit.views.text_payment_title")}
                                </span>
                              </div>

                              <div className="col-span-full mt-2">
                                <div
                                  role="group"
                                  aria-labelledby="cash_subscription_type"
                                  className="flex flex-col space-y-2"
                                >
                                  <label
                                    htmlFor="cash_subscription_type_1"
                                    className="flex items-center"
                                  >
                                    <InputRadio
                                      id="cash_subscription_type_1"
                                      key={1}
                                      value="1"
                                      name="cash_subscription_type"
                                      //checked={values.cash_subscription_type === 1}
                                      onChange={handleChange}
                                    />
                                    <span className="ml-2 text-sm">{t("direct_debit.views.text_payment_select_1")}</span>
                                  </label>

                                  <label
                                    htmlFor="cash_subscription_type_2"
                                    className="flex items-center"
                                  >
                                    <InputRadio
                                      id="cash_subscription_type_2"
                                      key={2}
                                      value="2"
                                      name="cash_subscription_type"
                                      //checked={values.cash_subscription_type === "cash_subscription_type"}
                                      //checked={values.cash_subscription_type === 2}
                                      onChange={handleChange}
                                    />
                                    <span className="ml-2 text-sm">
                                      {t("direct_debit.views.text_payment_select_2")} {" "} 09 {" "}
                                      
                                      {t("direct_debit.views.text_payment_select_4")} {" "} 09
                                      
                                      {t("direct_debit.views.text_payment_select_3")}</span>
                                  </label>
                                </div>
                              </div>
                            </>
                          )}


                          <div className="col-span-full mt-6">
                            <Select
                              name="farm"
                              span={t("general.mandatory")}
                              selected={optionsHacienda.find(
                                (option) => option.id === values.farm
                              )}
                              setSelected={(value) => {
                                setFieldValue("farm", value.id);
                              }}
                              options={optionsHacienda}
                              tittle={t("gti.views.generate_in_treasury")}
                            />
                          </div>

                          {values.farm > 1 && (
                            <>
                              <div className="col-span-full">
                                <Select
                                  tittle={t("gti.views.type_dni")}
                                  span={t("general.mandatory")}
                                  name="dni"
                                  selected={optionsTypeId.find(
                                    (option) => option.id === values.dni
                                  )}
                                  setSelected={(value) => {
                                    setFieldValue("dni", value.id);
                                  }}
                                  options={optionsTypeId}
                                />
                              </div>
                              <div className="col-span-full">
                                <InputWithCornerHint
                                  label={t("gti.views.nro_dni")}
                                  span={t("general.mandatory")}
                                  name="nroDni"
                                  type="number"
                                  value={values.nroDni}
                                  onChange={handleChange}
                                  error={errors.nroDni ? true : false}
                                  textError={errors.nroDni}
                                />
                              </div>
                            </>
                          )}


                          {values.cash_subscription_type == 1 && (
                            <div className="col-span-full mt-6">
                              <span className="text-gray-600 text-sm">
                                {t("direct_debit.views.text_payment_select_5")}
                              </span>
                            </div>
                          )}


                          {statusUser && (
                            <div className="col-span-full mt-2">
                              <div
                                role="group"
                                aria-labelledby="acceptPayment"
                                className="flex flex-col space-y-2"
                              >
                                {values.cash_subscription_type == 1 ? (
                                  <>
                                    <label
                                      htmlFor="accept-payment-parcial"
                                      className="flex items-center"
                                    >
                                      <InputRadio
                                        id="accept-payment-parcial"
                                        key={1}
                                        value="1"
                                        name="payment_complete"
                                        //checked={selectedOption === "payment_complete"}
                                        onChange={handleChange}
                                      />
                                      <span className="ml-2 text-sm">{t("direct_debit.views.payment_proportional")} ({currentFee.price/100} {currentFee.currency.toLocaleUpperCase()})</span>
                                    </label>

                                    <label
                                      htmlFor="accept-payment-no-parcial"
                                      className="flex items-center"
                                    >
                                      <InputRadio
                                        id="accept-payment-no-parcial"
                                        key={2}
                                        value="2"
                                        name="payment_complete"
                                        //checked={selectedOption === "payment_complete"}
                                        onChange={handleChange}
                                      />
                                      <span className="ml-2 text-sm">{t("direct_debit.views.payment_complete")} ({currentFee.price/100} {currentFee.currency.toLocaleUpperCase()})</span>
                                    </label>
                                  </>
                                ) : (
                                  <label
                                    htmlFor="accept-payment-no-parcial"
                                    className="flex items-center mt-3"
                                  >
                                    <InputRadio
                                      id="accept-payment-no-parcial"
                                      key={3}
                                      value="3"
                                      name="payment_complete"
                                      //checked={selectedOption === "payment_complete"}
                                      onChange={handleChange}
                                    />
                                    <span className="ml-2 text-sm">Pagar</span>
                                  </label>
                                )}
                                

                                
                              </div>
                            </div>
                          )}

                          {statusUser && (
                            <div className="col-span-full mt-4">
                              <p className="text-center text-sm text-gray-600">
                                El usuario con etiqueta{" "}
                                <span className="discount_name text-cyan-500">{statusUser.name}</span>
                                tiene un descuento del{" "}
                                <span className="discount_rate">{statusUser.discount}</span>
                                %.
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {selectedOption === "payment_cash" && (
                      <>
                        <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-t border-gray-200 pt-10">
                          <div className="flex items-center justify-center h-full text-center">
                            <div>
                              <h2 className="text-base font-semibold leading-7 text-gray-900">
                                {t("fees.views.title_modal_confirm_payment")}
                              </h2>
                            </div>
                          </div>
                          <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                            <div className="col-span-full">
                              <InputWithCornerHint
                                label={remainingAmount ? 'Monto por pagar' : t("user.views.mount_payment")}
                                span={t("general.mandatory")}
                                name="amount_to_pay"
                                type="number"
                                value={values.amount_to_pay}
                                onChange={handleChange}
                                error={!!errors.amount_to_pay}
                                textError={errors.amount_to_pay}
                              />
                            </div>
                            <div className="col-span-full">
                              <InputWithCornerHint
                                label={t("user.views.comments_code")}
                                span={t("general.optional")}
                                name="comment_code"
                                type="text"
                                value={values.comment_code}
                                onChange={handleChange}
                                error={!!errors.comment_code}
                                textError={errors.comment_code}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {selectedOption === "payment_direct_debit_manual" && (
                      <>
                        <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-t border-gray-200 pt-10">
                          <div className="flex items-center justify-center h-full text-center">
                            <div>
                              <h2 className="text-base font-semibold leading-7 text-gray-900">
                                {t("fees.views.title_modal_confirm_payment")}
                              </h2>
                            </div>
                          </div>
                          <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                            <div className="col-span-full">
                              <p className="text-sm text-gray-600 text-justify font-light">
                                {t("user.views.description_direct_debit_manual")}
                              </p>
                            </div>

                            <div className="col-span-full">
                              <InputWithCornerHint
                                name="iban"
                                label={t("user.views.IBAN")}
                                span={t("general.mandatory")}
                                value={values.iban}
                                onChange={handleChange}
                                error={errors.iban ? true : false}
                                textError={errors.iban}
                              />
                            </div>
                            <div className="col-span-full">
                              <InputWithCornerHint
                                name="name"
                                label={t("user.views.name")}
                                span={t("general.mandatory")}
                                value={values.name}
                                onChange={handleChange}
                                error={errors.name ? true : false}
                                textError={errors.name}
                              />
                            </div>
                            <div className="col-span-full">
                              <InputWithCornerHint
                                name="email"
                                label={t("subscription.views.billing_email")}
                                span={t("general.mandatory")}
                                value={values.email}
                                onChange={handleChange}
                                error={errors.email ? true : false}
                                textError={errors.email}
                              />
                            </div>
                            <div className="col-span-full">
                              <InputWithCornerHint
                                name="address"
                                label={t("user.views.address")}
                                span={t("general.mandatory")}
                                value={values.address}
                                onChange={handleChange}
                                error={errors.address ? true : false}
                                textError={errors.address}
                              />
                            </div>
                            <div className="col-span-full">
                              <SelectCountry
                                span={t("general.mandatory")}
                                selected={optionsCountryApi.find(
                                  (option) => option.id === values.country
                                )}
                                setSelected={(value) => {
                                  setFieldValue("country", value.id);
                                }}
                                options={optionsCountryApi}
                                tittle={t("branch.views.country")}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  </div>
                </div>
              </DialogCreate>
            );
          }}
        </Formik>
      )}

      {/* MODAL MODIFY FEE */}
      <Formik
        initialValues={{
          date: DateTime.now().toFormat("yyyy-MM-dd"),
        }}
        validationSchema={Yup.object().shape({
          date: Yup.date()
            .required(FIELD_REQUIRED_MESSAGE),
        })}
        onSubmit={async (values, formikHelpers) => {
          updateFeesUser({
            ...values,
            id: feeSelected.id,
            branchId: userInfo.branchId,
          });

          formikHelpers.setSubmitting(false);
          formikHelpers.resetForm();
        }}
      >
        {({ values, handleSubmit, handleChange, errors, touched }) => {
          return (
            <DialogCreate
              open={openDialogModifyFee}
              setOpen={setOpenDialogModifyFee}
              tittle={t("user.views.update_feeUser_Description")}
              tittleButtonCreate={t("general.save")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => setOpenDialogModifyFee(false)}
            >
              <div className="mt-6 mx-2">
                <div className="">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200 mt-12">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("user.views.update_feeUser")}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <div
                          role="group"
                          aria-labelledby="paymentMethod"
                          className="flex flex-col space-y-2 ml-2 mt-2"
                        >
                          <div className="col-span-full">
                            <InputWithCornerHint
                              name="date"
                              label={t("user.views.new_date_renovation")}
                              span={t("general.mandatory")}
                              min={DateTime.now().toFormat("yyyy-MM-dd")}
                              type="date"
                              value={values.date}
                              onChange={handleChange}
                              error={errors.date && touched.date}
                              textError={errors.date}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          );
        }}
      </Formik>

      {/* MODAL NEXT PAYMENT FEE */}
      <Formik
        enableReinitialize
        initialValues={initialValuesNextPay}
        validationSchema={Yup.object().shape({
          price: Yup.number()
            .required(FIELD_REQUIRED_MESSAGE),
          reason_next: Yup.string()
            .required(FIELD_REQUIRED_MESSAGE),
        })}
        onSubmit={async (values, formikHelpers) => {
          prayNextFee({
            ...values,
            user_id: id,
            fee_id: feeSelected.id,
            branchId: userInfo.branchId,
          });

          formikHelpers.setSubmitting(false);
          formikHelpers.resetForm();
        }}
      >
        {({ values, handleSubmit, handleChange, errors, touched }) => {
          return (
            <DialogCreate
              open={openDialogNextPayment}
              setOpen={setOpenDialogNextPayment}
              tittle={t("fees.views.next_pay")}
              tittleButtonCreate={t("general.accept")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => setOpenDialogNextPayment(false)}
            >
              <div className="mt-6 mx-2">
                <div className="">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200 mt-12">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("fees.views.next_pay")}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <div
                          role="group"
                          aria-labelledby="paymentMethod"
                          className="flex flex-col space-y-2 ml-2 mt-2"
                        >
                          <div className="col-span-full">
                            <InputWithCornerHint
                              name="price"
                              label={t("user.views.next_pay_price")}
                              span={t("general.mandatory")}
                              type="number"
                              value={values.price}
                              onChange={handleChange}
                              error={errors.price && touched.price}
                              textError={errors.price}
                            />
                          </div>

                          <div className="col-span-full">
                            <InputWithCornerHint
                              name="reason_next"
                              label={t("customer-to-gym-subscription.views.motive")}
                              span={t("general.mandatory")}
                              type="text"
                              value={values.reason_next}
                              onChange={handleChange}
                              error={errors.reason_next && touched.reason_next}
                              textError={errors.reason_next}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          )
        }}
      </Formik>

      {/* MODAL DISCONTINUE FEE */}
      <Formik
        enableReinitialize
        initialValues={{
          reason_id: 0,
          predicted_unsubscribe_date: DateTime.now().toFormat("yyyy-MM-dd"),
        }}
        validationSchema={Yup.object().shape({
          reason_id: Yup.number()
            .optional(),
          predicted_unsubscribe_date: Yup.date()
            .required(FIELD_REQUIRED_MESSAGE),
        })}
        onSubmit={async (values, formikHelpers) => {
          unsubscribeUser({
            ...values,
            user_id: id,
            fee_id: feeSelected.id,
            branchId: userInfo.branchId,
          });

          formikHelpers.setSubmitting(false);
          formikHelpers.resetForm();
        }}
      >
        {({ values, handleSubmit, handleChange, setFieldValue, errors, touched }) => {
          return (
            <DialogCreate
              open={openDialogDiscontinue}
              setOpen={setOpenDialogDiscontinue}
              tittle={t("fees.views.title_modal_confirm_low")}
              tittleButtonCreate={t("general.accept")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => setOpenDialogDiscontinue(false)}
            >
              <div className="mt-6 mx-2">
                <div className="">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200 mt-12">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("fees.views.text_modal_confirm_low")}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <div
                          role="group"
                          aria-labelledby="paymentMethod"
                          className="flex flex-col space-y-2 ml-2 mt-2"
                        >
                          <div className="col-span-full">
                            <Select
                              name="reason_id"
                              span={t("general.optional")}
                              selected={optionsTypePayment.find(
                                (option) => option.id === values.reason_id
                              )}
                              setSelected={(value) => {
                                setFieldValue("reason_id", value.id);
                              }}
                              options={reasonsQuery.data ? reasonsQuery.data.filter(value => value.type == 1) : []}
                              tittle={t(
                                "user.views.reason_for_withdrawal"
                              )}
                              error={errors.reason_id ? true : false}
                              textError={errors.reason_id}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                                name="predicted_unsubscribe_date"
                                label={t("compliance.table_from")}
                                span={t("general.mandatory")}
                                min={DateTime.now().toFormat("yyyy-MM-dd")}
                                type="date"
                                value={values.predicted_unsubscribe_date}
                                onChange={handleChange}
                                error={errors.predicted_unsubscribe_date && touched.predicted_unsubscribe_date}
                                textError={errors.predicted_unsubscribe_date}
                              />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          );
        }}
      </Formik>

      {/* MODAL CANCEL FEE */}
      <Formik
        enableReinitialize
        initialValues={{}}
        validationSchema={Yup.object().shape({})}
        onSubmit={async (values, formikHelpers) => {
          deleteFeeToUser({
            user_id: id,
            fee_id: feeSelected.id,
            branchId: userInfo.branchId,
          });

          formikHelpers.setSubmitting(false);
          formikHelpers.resetForm();
        }}
      >
        {({ handleSubmit }) => {
          return (
            <DialogCreate
              open={openDialogCancelFee}
              setOpen={setOpenDialogCancelFee}
              tittle={t("fees.views.cancel_fee")}
              tittleButtonCreate={t("general.accept")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => setOpenDialogCancelFee(false)}
            >
              <div className="mt-6 mx-2">
                <div className="">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200 mt-12">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("fees.views.cancel")}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <div
                          role="group"
                          aria-labelledby="paymentMethod"
                          className="flex flex-col space-y-2 ml-2 mt-2"
                        >
                          <div className="col-span-full">
                            <p
                              className="text-sm text-gray-600 text-center"
                            >
                              {t("fees.views.cancel_text")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          )
        }}
      </Formik>

      {/* MODAL PAUSE FEE */}
      <Formik
        initialValues={{
          dateInitial: "",
          dateEnd: "",
        }}
        validationSchema={Yup.object().shape({
          dateInitial: Yup.date()
            .required(FIELD_REQUIRED_MESSAGE),
          dateEnd: Yup.date()
            .required(FIELD_REQUIRED_MESSAGE),
        })}
        onSubmit={async (values, formikHelpers) => {
          const differenceInDays = await getDifferenceInDays(values.dateInitial, values.dateEnd);

          pauseFeeToUser({
            ...values,
            user_id: id,
            branchId: id,
            days: differenceInDays,
            fee_id: feeSelected.id,
          });

          formikHelpers.setSubmitting(false);
          formikHelpers.resetForm();
        }}
      >
        {({ values, handleSubmit, setFieldValue }) => {
          return (
            <DialogCreate
              open={openDialogPauseFee}
              setOpen={setOpenDialogPauseFee}
              tittle={t("fees.views.pause")}
              tittleButtonCreate={t("general.accept")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => setOpenDialogPauseFee(false)}
            >
              <div className="mt-6 mx-2">
                <div className="">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200 mt-12">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("fees.views.pause")}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <div
                          role="group"
                          aria-labelledby="paymentMethod"
                          className="flex flex-col space-y-2 ml-2 mt-2"
                        >
                          <div className="col-span-full">
                            <DateRangePicker
                              id="agreements-date"
                              label={t("lesson.views.interval_date")}
                              value={{
                                startDate: values.dateInitial
                                  ? DateTime.fromFormat(
                                      values.dateInitial,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date(),
                                endDate: values.dateEnd
                                  ? DateTime.fromFormat(
                                      values.dateEnd,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date(),
                              }}
                              onDateChange={(dateInitial, dateEnd) => {
                                setFieldValue(
                                  "dateInitial",
                                  DateTime.fromJSDate(dateInitial).toFormat("yyyy-MM-dd")
                                );
                                setFieldValue(
                                  "dateEnd",
                                  DateTime.fromJSDate(dateEnd).toFormat("yyyy-MM-dd")
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          );
        }}
      </Formik>

    </Fragment>
  );
}
